import {
    Typography,
    useTheme,
    RangeBlocks,
    PargodaTagsEditor,
} from '../../../base';
import {
    CandidateItemWrapper,
    CandidateNameWrapper,
    ScoreWrapper,
    RangeBarWrapper,
} from './CandidatesMenu.styles';
import {
    IStepUser,
    createScoreRangeConfig,
    overallScoreLabels,
    scaleScores,
    ITag,
} from '../../../common';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../../routes/RoutePaths';

interface CandidateItemProps {
    candidate: IStepUser;
    candidateScore?: number;
    candidateTags?: Array<ITag>;
    applicationId: number;
}

const CandidateItem = (props: CandidateItemProps) => {
    const {
        candidate,
        candidateScore = 0,
        candidateTags = [],
        applicationId,
    } = props;
    const theme = useTheme();
    const navigate = useNavigate();

    const candidateScaledScore = scaleScores(candidateScore);
    const scoreRangeConfig = createScoreRangeConfig(overallScoreLabels);

    const handleClick = () => {
        navigate(`${RoutePaths.jobApplications}/${applicationId}`);
    };

    return (
        <CandidateItemWrapper onClick={handleClick}>
            <CandidateNameWrapper>
                <Typography variant="subtitle1" color="text.primary">
                    {candidate.name}
                </Typography>
            </CandidateNameWrapper>
            <ScoreWrapper>
                <RangeBarWrapper>
                    <RangeBlocks
                        externalValue={{
                            from: candidateScaledScore > 0 ? 1 : 0,
                            to: candidateScaledScore,
                        }}
                        disabled
                        showSelectionText={false}
                        fillColor={theme.palette.primary.main}
                    />
                </RangeBarWrapper>
                <Typography
                    variant="body2"
                    color="text.primary"
                    fontSize="0.75rem"
                >
                    {scoreRangeConfig.getLabel(
                        candidateScaledScore,
                        candidateScaledScore
                    )}
                </Typography>
            </ScoreWrapper>
            <PargodaTagsEditor
                externalAppliedTags={candidateTags}
                objectId={applicationId}
                modelName="job_application"
                isFilter={true}
                disableTagRemoval={true}
            />
        </CandidateItemWrapper>
    );
};

export default CandidateItem;
